export default "__VITE_ASSET__$vUArf4S__";